"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var clone = require('clone');

var tv4 = require('tv4');

var HealthSymptoms = /*#__PURE__*/function () {
  function HealthSymptoms(opt) {
    _classCallCheck(this, HealthSymptoms);

    this.general = null;
    this.inhalation = null;
    this.skin = null;
    this.eye = null;
    this.ingestion = null;
    this.fire = null;
    this.explosion = null;
    this.exposure = null;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(HealthSymptoms, [{
    key: "fillObject",
    value: function fillObject(opt) {
      var _this = this;

      Object.keys(this).forEach(function (prop) {
        _this[prop] = opt[prop] || null;
      });
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, HealthSymptoms.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'health-symptoms.schema.json',
        type: 'object',
        properties: {
          general: {
            type: ['string', 'null']
          },
          inhalation: {
            type: ['string', 'null']
          },
          skin: {
            type: ['string', 'null']
          },
          eye: {
            type: ['string', 'null']
          },
          ingestion: {
            type: ['string', 'null']
          },
          fire: {
            type: ['string', 'null']
          },
          explosion: {
            type: ['string', 'null']
          },
          exposure: {
            type: ['string', 'null']
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return HealthSymptoms;
}();

module.exports = HealthSymptoms;